import type { LevelDef } from '../sim/level/schema';

/** A quiet circuit arena: strong platform edges, roomy lanes and no full-screen glow. */
export const neonCircuit: LevelDef = {
  id: 'neon-circuit',
  name: 'Circuit',
  theme: 'neon',
  bounds: { x: 0, y: 0, w: 28, h: 16 },
  killMargin: 6,
  spawns: [{ x: 4, y: 6.1 }, { x: 24, y: 6.1 }, { x: 9, y: 3.5 }, { x: 19, y: 3.5 }],
  drops: { enabled: true, xMin: 3, xMax: 25, intervalScale: 1 },
  objects: [
    { type: 'solid', x: 14, y: 1, w: 28, h: 2 },
    { type: 'solid', x: 5.5, y: 4.4, w: 5, h: 0.4 },
    { type: 'solid', x: 22.5, y: 4.4, w: 5, h: 0.4 },
    { type: 'solid', x: 14, y: 3.1, w: 6, h: 2.2 },
    { type: 'solid', x: 14, y: 6.6, w: 8, h: 0.4 },
  ],
  decor: [
    { kind: 'neon-grid', x: 14, y: 2, scale: 1 },
    { kind: 'neon-portal', x: 14, y: 2, scale: 1 },
    { kind: 'neon-pylon', x: 2, y: 2, scale: 0.9 },
    { kind: 'neon-pylon', x: 26, y: 2, scale: 0.9 },
    { kind: 'neon-trace', x: 5.5, y: 4.2, scale: 0.8 },
    { kind: 'neon-trace', x: 22.5, y: 4.2, scale: 0.8 },
  ],
};

/** The timed beam only guards the top bridge; every fighter has a permanent route underneath. */
export const neonSkyline: LevelDef = {
  id: 'neon-skyline',
  name: 'Skyline',
  theme: 'neon',
  bounds: { x: 0, y: 0, w: 36, h: 18 },
  killMargin: 6,
  spawns: [
    { x: 3, y: 3.5 }, { x: 33, y: 3.5 },
    { x: 7, y: 6.1 }, { x: 29, y: 6.1 },
    { x: 11.5, y: 3.5 }, { x: 24.5, y: 3.5 },
    { x: 15, y: 6.1 }, { x: 21, y: 6.1 },
  ],
  drops: { enabled: true, xMin: 3, xMax: 33, intervalScale: 0.9 },
  objects: [
    { type: 'solid', x: 18, y: 1, w: 36, h: 2 },
    { type: 'solid', x: 7, y: 4.4, w: 6, h: 0.4 },
    { type: 'solid', x: 18, y: 4.4, w: 8, h: 0.4 },
    { type: 'solid', x: 29, y: 4.4, w: 6, h: 0.4 },
    { type: 'solid', x: 18, y: 7, w: 3.5, h: 0.4 },
    { type: 'laser', x: 16.25, y: 8.1, w: 3.5, offTicks: 240, onTicks: 30, warningTicks: 60, delay: 0 },
  ],
  decor: [
    { kind: 'neon-grid', x: 18, y: 2, scale: 1.3 },
    { kind: 'neon-skyline', x: 18, y: 2, scale: 1 },
    { kind: 'neon-portal', x: 18, y: 2, scale: 1.15 },
    { kind: 'neon-pylon', x: 2, y: 2 },
    { kind: 'neon-pylon', x: 34, y: 2 },
    { kind: 'neon-trace', x: 7, y: 4.2 },
    { kind: 'neon-trace', x: 29, y: 4.2 },
  ],
};

export const NEON_ARENAS: LevelDef[] = [neonCircuit, neonSkyline];
